import TextField from './TextField';
import PhoneField from './PhoneField';

export default TextField;

export { TextField, PhoneField };



/** WEBPACK FOOTER **
 ** ./src/components/FieldKit/index.jsx
 **/